import { Page, Button, InlineStack, BlockStack } from '@shopify/polaris';
import { usePaginatedResource } from '../../../shared/hooks/usePaginatedResource';
import { ErrorBanner } from '../../../shared/components/ErrorBanner';
import { DataTable } from '../../../shared/components/DataTable';
import { listTrackingEvents } from './api';
import { trackingEventToRow } from './TrackingEventRow';

const COLUMNS = [
  { id: 'consignment', title: 'Consignment' },
  { id: 'status', title: 'Status' },
  { id: 'desc', title: 'Description' },
  { id: 'occurred', title: 'Occurred at' },
];

export function TrackingLogPage(): JSX.Element {
  const { items, loading, error, hasMore, loadMore } = usePaginatedResource(
    ['tracking-events'],
    (api, cursor) => listTrackingEvents(api, { cursor, limit: 50 }),
  );

  return (
    <Page title="Tracking events" subtitle="All TNT tracking updates received">
      <BlockStack gap="400">
        {error ? <ErrorBanner error={error} /> : null}
        <DataTable
          columns={COLUMNS}
          rows={items.map(trackingEventToRow)}
          loading={loading && items.length === 0}
          resourceName={{ singular: 'event', plural: 'events' }}
          emptyState={{ heading: 'No tracking events yet' }}
        />
        {hasMore ? (
          <InlineStack align="center">
            <Button onClick={loadMore} loading={loading}>Load more</Button>
          </InlineStack>
        ) : null}
      </BlockStack>
    </Page>
  );
}
